// @flow
import React, { type Node } from 'react';
import SettingsEtcContainer from '../../../containers/settings/SettingsEtcContainer';
import './SettingSection.scss';

type Props = {
  children: Node,
  name: string,
};

const SettingSection = ({ children, name }: Props) => (
  <section className="SettingSection">
    <div className="header">
      <div className="name">{name}</div>
      <SettingsEtcContainer />
    </div>
    <div className="section-contents">{children}</div>
  </section>
);

export default SettingSection;



// WEBPACK FOOTER //
// ./src/components/settings/SettingSection/SettingSection.js